import React from "react";
import { ArcStack, ArcText } from "@src/core/ui";
import { arcDateWithTime } from "@src/core/extensions";
import { ArcOrderCardDetailsProps } from "./types";

const ArcOrderCardDetails: React.FC<ArcOrderCardDetailsProps> = ({
  order,
  fullWidth = true,
  isInFlight = false,
}) => {
  const getOrderData = () => {
    const orderData = order as any;
    // If it has orders array (Orders tab structure), get the first order
    if (orderData.orders && orderData.orders.length > 0) {
      return {
        id: orderData.orders[0].id,
        missionId: orderData.missionId,
        createDate: orderData.orders[0].createDate,
        deliveryLocation: orderData.orders[0].deliveryLocation,
        clientName: orderData.orders[0].clientName,
        status: orderData.orders[0].status,
      };
    }
    // Otherwise, use direct order data (History tab structure)
    return {
      id: orderData.id,
      missionId: orderData.missionId,
      createDate: orderData.createDate,
      deliveryLocation: orderData.deliveryLocation,
      clientName: orderData.clientName,
      status: orderData.status,
    };
  };

  const orderData = getOrderData();

  if (fullWidth) {
    // Full width layout (History tab) - original layout
    return (
      <ArcStack direction="column" spacing={1}>
        <ArcStack direction="row" justifyContent="space-between">
          <ArcText.h6 color="white" fontSize={14}>
            #{orderData.id || orderData.missionId?.slice(0, 8) + "..." || "N/A"}
          </ArcText.h6>
          <ArcText color="text.secondary" fontSize={12}>
            {arcDateWithTime(orderData.createDate)}
          </ArcText>
        </ArcStack>
        <ArcText
          color="text.secondary"
          fontSize={12}
          sx={{
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
          }}
        >
          {orderData.deliveryLocation?.address || "Unknown destination"}
        </ArcText>
      </ArcStack>
    );
  } else {
    // Column layout (Orders tab) - date, space, order ID, address
    return (
      <ArcStack direction="column">
        <ArcText color="text.secondary" fontSize={12}>
          {arcDateWithTime(orderData.createDate)}
        </ArcText>
        <ArcStack>
          <ArcText.h6 color="white" fontSize={12} fontWeight={600} mt={'8px'}>
            #{orderData.id || orderData.missionId?.slice(0, 8) + "..." || "N/A"}
          </ArcText.h6>
        </ArcStack>
        <ArcText
          color="text.secondary"
          fontSize={12}
          sx={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            marginTop: "4px",
          }}
        >
          {orderData.deliveryLocation?.address || "Unknown destination"}
        </ArcText>
        {isInFlight && (
          <ArcText color="text.secondary" fontSize={12} marginTop={'8px'}>
            {order?.drone?.name}
          </ArcText>
        )}
      </ArcStack>
    );
  }
};

export default ArcOrderCardDetails;
